module.exports = __webpack_public_path__ + "static/media/schoolpic03.d83270d1.png";